import React from "react";
import * as ConstantsTable from "../../consts/LocalizationTable.js";
import MaterialTable from "material-table";
import GpsFixedIcon from "@material-ui/icons/GpsFixed";
import Style from "../../styles/js/Styles.js";

function ReportsTable({ handleClickOpen, entries, handleViewMap }) {
  const [selected, setSelected] = React.useState(null);

  const localViewMap = (row) => {
    handleViewMap(row);
    setSelected(row.tableData.id);
  };

  return (
    <MaterialTable
      localization={{
        ...ConstantsTable.LOCALIZATION_TABLE,
        header: {
          actions: "Acciones",
        },
      }}
      options={{
        search: false,
        pageSize: 10,
      }}
      actions={[
        {
          icon: "search",
          tooltip: "Más información",
          onClick: (event, rowData) => handleClickOpen(event, rowData),
        },
        {
          icon: () => <GpsFixedIcon />,
          tooltip: "Ver en el mapa",
          onClick: (event, rowData) => localViewMap(rowData),
        },
      ]}
      title="Reportes"
      columns={[
        {
          title: "Usuario",
          field: "userName",
          cellStyle: {
            width: "20%",
            maxWidth: "20%",
            textAlign: "left",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            margin: "0px",
            padding: "0px",
          },
          headerStyle: {
            width: "20%",
            maxWidth: "20%",
            textAlign: "left",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            margin: "0px",
            padding: "0px",
          },
        },
        {
          title: "Tipo",
          field: "reportTypeName",
          cellStyle: {
            width: "5px",
            maxWidth: "5px",
            textAlign: "left",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            margin: "0px",
            padding: "0px",
          },
          headerStyle: {
            width: "5px",
            maxWidth: "5px",
            textAlign: "left",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            margin: "0px",
            padding: "0px",
          },
        },
        {
          title: "Descripcion",
          field: "description",
          cellStyle: {
            width: "20vh",
            maxWidth: "20vh",
            textAlign: "left",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            margin: "0px",
            padding: "0px",
          },
          headerStyle: {
            width: "20vh",
            maxWidth: "20vh",
            textAlign: "left",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            margin: "0px",
            padding: "0px",
          },
        },
        {
          title: "Estado",
          field: "state",
          lookup: {
            0: "Pendiente de confirmación",
            1: "Recepcionado",
            2: "En progreso",
            3: "Finalizado",
            4: "Desestimado",
          },
          cellStyle: {
            width: "20vh",
            maxWidth: "20vh",
            textAlign: "left",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            margin: "0px",
            padding: "0px",
          },
          headerStyle: {
            width: "20vh",
            maxWidth: "20vh",
            textAlign: "left",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            margin: "0px",
            padding: "0px",
          },
        },
      ]}
      options={{
        defaultPageSize: 10,
        minRows: 10,
        pageSize: 10,
        rowStyle: (rowData) => ({
          backgroundColor: selected === rowData.tableData.id ? "#EEE" : "#FFF",
        }),
      }}
      data={entries.data}
    />
  );
}

export default React.memo(ReportsTable);
